// reducers.js

import {
  ERROR_WEBSOCKET,
  PENDING_WEBSOCKET,
  CONNECT_WEBSOCKET,
  MESSAGE_WEBSOCKET_V1,
  DISCONNECT_WEBSOCKET,
  SET_WEB_CHAT_ID,
  SET_WEB_CHAT_MESSAGES,
  ADD_PENDING_MESSAGE,
  DISPLAY_RETRY_MESSAGE,
  CLEAR_CHAT_MESSAGES,
  CLEAR_ALL,
} from "../constants/actions";

const initialState = {
  ws: false,
  isConnected: false,
  message: {},
  error: false,
  pending: false,
  data: {},
  channel: {},
  pendingMessages: [],
  isNewChat: false,
  retry: false,
};

const webSocketReducer = (state = initialState, action) => {
  switch (action.type) {
    case PENDING_WEBSOCKET:
      return {
        ...state,
        pending: true,
      };

    case CONNECT_WEBSOCKET:
      return {
        ...state,
        isConnected: true,
        pending: false,
        ws: action.payload,
      };
    case SET_WEB_CHAT_ID:
      return {
        ...state,
        channel: { ...action.payload },
      };
    case SET_WEB_CHAT_MESSAGES:
      const Messages = action.payload.reduce((result, item) => {
        return {
          ...result,
          [item.id]: {
            ...item,
            server: {
              response: item.server.response,
              error: item.server.error,
            },
          },
        };
      }, {});
      return {
        ...state,
        message: { ...Messages },
        pending: false,
      };

    case MESSAGE_WEBSOCKET_V1:
      return {
        ...state,
        data: action.payload,
        message: {
          ...state.message,
          [action.payload.id]: action.payload,
        },
        channel: {
          id: action.payload.id,
          name: action.payload.name,
        },
        pending: false,
      };

    case ERROR_WEBSOCKET:
      return {
        ...state,
        error: action.payload,
        pending: false,
      };

    case DISCONNECT_WEBSOCKET:
      return {
        ...state,
        isConnected: false,
        pending: false,
        data: {},
        ws: action.payload,
      };

    case ADD_PENDING_MESSAGE:
      const pendingMessages = state.pendingMessages;
      pendingMessages.push(action.payload);
      return {
        ...state,
        pendingMessages: pendingMessages,
      };

    case DISPLAY_RETRY_MESSAGE:
      return {
        ...state,
        retry: action.payload, // Store the failed message data here
        pending: false,
      };

    case CLEAR_ALL:
      return initialState;

    case CLEAR_CHAT_MESSAGES:
      return {
        ...state,
        message: {},
        pending: false,
      };

    default:
      return state;
  }
};

export default webSocketReducer;
